import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {DisplayConsentContainerComponent} from './container/display-consent-container.component';
import {DisplayConsentTextComponent} from './components/display-consent-text/display-consent-text.component';
import {StoreModule} from '@ngrx/store';
import {ConsentReducer} from './store';
import {DisplayConsentOutlineComponent} from './components/display-consent-menu/display-consent-outline/display-consent-outline.component';
import {EffectsModule} from '@ngrx/effects';
import {ConsentEffects} from './store/consent-effects';
import {MatSidenavModule} from '@angular/material/sidenav';
import {SkipDialogComponent} from './dialogs/skip-dialog/skip-dialog.component';
import {TranslateModule} from '@ngx-translate/core';
import {CoreModule} from '@core/core.module';
import {DisplayConsentHeaderComponent} from './components/display-consent-header/display-consent-header.component';
import {SharedModule} from '@shared/shared.module';
import {DisplayConsentFooterComponent} from './components/display-consent-footer/display-consent-footer.component';
import {MatDialogModule} from '@angular/material/dialog';
import {SubmitDialogComponent} from './dialogs/submit-dialog/submit-dialog.component';
import {MatInputModule} from '@angular/material/input';
import {DisplayConsentMenuComponent} from './components/display-consent-menu/display-consent-menu.component';
import {DisplayConsentCommentsComponent} from './components/display-consent-menu/display-consent-comments/display-consent-comments.component';
import {CommentDialogComponent} from './dialogs/comment-dialog/comment-dialog.component';
import {MatIconModule} from '@angular/material/icon';
import {DeleteConfirmationDialogComponent} from './dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component';
import {DisplayConsentSettingsComponent} from './components/display-consent-menu/display-consent-settings/display-consent-settings.component';
import {MatSliderModule} from '@angular/material/slider';
import {A11yModule} from "@angular/cdk/a11y";

const routes: Routes = [
    {path: 'consent', component: DisplayConsentContainerComponent}
];

@NgModule({
    declarations: [
        DisplayConsentContainerComponent,
        DisplayConsentTextComponent,
        DisplayConsentOutlineComponent,
        SkipDialogComponent,
        SubmitDialogComponent,
        DisplayConsentHeaderComponent,
        DisplayConsentFooterComponent,
        DisplayConsentMenuComponent,
        DisplayConsentCommentsComponent,
        CommentDialogComponent,
        DeleteConfirmationDialogComponent,
        DisplayConsentSettingsComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        StoreModule.forFeature(ConsentReducer.REDUCER_NAME, ConsentReducer.consentReducer),
        EffectsModule.forFeature([ConsentEffects]),
        CommonModule,
        MatSidenavModule,
        TranslateModule,
        CoreModule,
        SharedModule,
        MatDialogModule,
        MatInputModule,
        MatIconModule,
        MatSliderModule,
        A11yModule
    ],
    exports: [
        DisplayConsentContainerComponent,
        DisplayConsentHeaderComponent,
        DisplayConsentTextComponent,
        DisplayConsentOutlineComponent,
        DisplayConsentMenuComponent
    ]
})
export class DisplayConsentModule {
}
